var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortGray = function SvgSortGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "stats-btn-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.673,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort-gray_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108388",
    d: "M285 222.14h16.673v20H285Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285 -222.14)",
    clipPath: "url(#sort-gray_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108387",
    d: "M297.645 239.296v-16.32a.833.833 0 1 1 1.667 0v16.32l.941-.941a.833.833 0 0 1 1.178 1.179l-2.368 2.368a.82.82 0 0 1-.581.241h-.006a.821.821 0 0 1-.58-.239l-2.368-2.368a.834.834 0 0 1 1.179-1.179Zm-8.617-14.3v16.315a.833.833 0 1 1-1.667 0v-16.324l-.941.941a.834.834 0 0 1-1.179-1.179l2.368-2.368a.82.82 0 0 1 .581-.241h.006a.821.821 0 0 1 .58.239l2.368 2.368a.834.834 0 0 1-1.179 1.179Z",
    fillRule: "evenodd"
  }))));
};
export default SvgSortGray;